import {useEffect} from 'react';
import {useKeycloak} from '@react-keycloak/web';
import CoreHeader from '../../core/components/Header';
import ConsumerThemeProvider from './ConsumerTheme.js';
import {setCurrentUserData,setCurrentProfilePicture,useCurrentProfilePicture} from './CurrentUser.js';
import {getMyProfilePicture} from '../integration/Api.js';

// AppConfig APP_NAME_HEADER only arrives with globalData after login - this is
// the name shown before that (logged-out landing). Keep in sync with
// APP_NAME_HEADER and the Keycloak login bar (coda-login-theme styles.css).
const APP_NAME='Coda for Lane 4';

// Same core header for everyone - consumers (and the logged-out landing page)
// just get it under the navy bar theme. It keeps the Coda app name
// (APP_NAME_HEADER) rather than a Lane4 logo, for the Coda identity.
function Header(props){
    const {keycloak}=useKeycloak();
    const profilePicture=useCurrentProfilePicture();
    const userId=props.userData?.user_id;

    useEffect(()=>{
        setCurrentUserData(props.userData);
    },[props.userData]);

    // Load the own profile picture once per login for the header avatar (and Home/Profile)
    useEffect(()=>{
        if(!keycloak.authenticated||!userId){
            setCurrentProfilePicture(null);
            return;
        }
        let cancelled=false;
        getMyProfilePicture().then((data)=>{
            if(!cancelled&&!data?.error){
                setCurrentProfilePicture(data.picture);
            }
        });
        return ()=>{cancelled=true;};
    },[keycloak.authenticated,userId]);

    return (
        <ConsumerThemeProvider userData={props.userData} bar force={keycloak.authenticated===false}>
            <CoreHeader {...props} appName={APP_NAME} avatarSrc={profilePicture}/>
        </ConsumerThemeProvider>
    );
}
export default Header;
